import React, { useState } from 'react';
import MobileProviderLabInfo from './MobileProviderLabInfo';
import MobileProviderMyUploads from './MobileProviderMyUploads';
import MobileProviderHelpCenter from './MobileProviderHelpCenter';
import MobileProviderPrivacyPolicy from './MobileProviderPrivacyPolicy';
import MobileProviderSettings from './MobileProviderSettings';

export default function MobileProviderProfile({ user, onLogout }) {
  const [screen, setScreen] = useState('main');

  if (screen === 'labinfo') return <MobileProviderLabInfo user={user} onBack={() => setScreen('main')} />;
  if (screen === 'uploads') return <MobileProviderMyUploads user={user} onBack={() => setScreen('main')} />;
  if (screen === 'help') return <MobileProviderHelpCenter onBack={() => setScreen('main')} />;
  if (screen === 'privacy') return <MobileProviderPrivacyPolicy onBack={() => setScreen('main')} />;
  if (screen === 'settings') return <MobileProviderSettings onBack={() => setScreen('main')} />;

  const menuItems = [
    { id: 'labinfo',  icon: 'science',       label: 'Lab Information',  desc: 'Manage facility details',      bg: '#e1f3ee', color: '#0f6b5c' },
    { id: 'uploads',  icon: 'upload_file',   label: 'My Uploads',       desc: 'History of patient reports',   bg: '#ece7fb', color: '#5a3fd6' },
    { id: 'help',     icon: 'support_agent', label: 'Help Center',      desc: 'FAQs and support',             bg: '#dde7fb', color: '#3b5cc4' },
    { id: 'privacy',  icon: 'encrypted',     label: 'Privacy Policy',   desc: 'Data protection terms',        bg: '#fbe3ec', color: '#c0286e' },
    { id: 'settings', icon: 'settings',      label: 'Settings',         desc: 'Manage your preferences',      bg: '#e7e7ea', color: '#4b4d57' },
  ];

  return (
    <div className="pb-6" style={{ fontFamily: 'Inter, sans-serif' }}>

      {/* Hero Card */}
      <section className="relative mx-4 mt-4 rounded-2xl p-6 flex flex-col items-center text-center overflow-hidden"
        style={{ background: '#0f6b5c' }}>
        <span className="material-symbols-outlined absolute opacity-[0.06] text-white"
          style={{ top: '-10px', right: '-30px', fontSize: '220px', fontVariationSettings: '"FILL" 1' }}>shield</span>

        <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center shadow-lg mb-3 relative z-10 border-4 border-white/30">
          <span className="text-3xl font-black" style={{ color: '#0f6b5c' }}>
            {user?.name?.charAt(0) || 'A'}
          </span>
        </div>

        <div className="flex items-center gap-2 mb-1 relative z-10">
          <h2 className="text-white font-black text-xl">{user?.name}</h2>
          <span className="material-symbols-outlined text-white" style={{ fontSize: '20px', fontVariationSettings: '"FILL" 1' }}>verified</span>
        </div>
        <p className="text-white/70 text-sm relative z-10">Healthcare Provider</p>
      </section>

      {/* Menu Items */}
      <div className="px-4 mt-5 space-y-3">
        {menuItems.map(item => (
          <button key={item.id} onClick={() => setScreen(item.id)}
            className="w-full bg-white rounded-2xl shadow-sm p-4 flex items-center gap-4 text-left active:scale-[0.99] transition-all">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0"
              style={{ background: item.bg }}>
              <span className="material-symbols-outlined" style={{ fontSize: '22px', color: item.color, fontVariationSettings: '"FILL" 1' }}>
                {item.icon}
              </span>
            </div>
            <div className="flex-1">
              <p className="font-extrabold text-[#141a3d] text-base">{item.label}</p>
              <p className="text-sm text-gray-400 mt-0.5">{item.desc}</p>
            </div>
            <span className="material-symbols-outlined text-gray-300 shrink-0">chevron_right</span>
          </button>
        ))}

        {/* Logout */}
        <button onClick={onLogout}
          className="w-full bg-white rounded-2xl shadow-sm p-4 flex items-center justify-center gap-2 active:scale-[0.99] transition-all mt-2">
          <span className="material-symbols-outlined" style={{ color: '#e53935', fontSize: '20px' }}>logout</span>
          <span className="font-bold text-base" style={{ color: '#e53935' }}>Logout</span>
        </button>

        <p className="text-center text-xs text-gray-400 flex items-center justify-center gap-1 mt-3 pb-2">
          <span className="material-symbols-outlined" style={{ fontSize: '13px' }}>lock</span>
          HIPAA Compliant • Secure • Version 2.1.0
        </p>
      </div>
    </div>
  );
}